import script from "./OverlayComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./OverlayComponent.vue?vue&type=script&lang=ts&setup=true"

import "./OverlayComponent.vue?vue&type=style&index=0&id=32f83c1a&scoped=true&lang=css"

import exportComponent from "/home/node/skat32-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32f83c1a"]])

export default __exports__